import microloan from './microloan';
import loanDetails from './loan-details';
import applyLoan from './applyLoan';

export default [microloan, loanDetails, applyLoan];
